<template>
  <div v-if="isAuthenticated">
    <div
      v-if="stockType || stockType == 0"
      class="w-fit whitespace-nowrap font-inter text-sm leading-5"
      :class="`stocktype-${stockType}`"
    >
      <span v-if="stockType == 0"> {{ $t("custom.stock.no_order_possible") }}</span>
      <span v-if="stockType == 1">{{ $t("custom.stock.in_stock") }}</span>
      <span v-if="stockType == 2">{{ $t("custom.stock.order_item") }}</span>
      <span v-if="stockType == 3">{{ $t("custom.stock.partially_available") }}</span>
    </div>
    <div v-else class="w-fit whitespace-nowrap font-inter text-sm leading-5 text-[color:var(--color-in-stock-out)]">
      {{ $t("common.messages.product_status_not_available") }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUser } from "@/shared/account";

interface IProps {
  isInStock?: boolean;
  isAvailable?: boolean;
  isDigital?: boolean;
  quantity?: number | null;
  stockType?: number;
}

withDefaults(defineProps<IProps>(), {
  isAvailable: true,
  quantity: null,
});

const { isAuthenticated } = useUser();
</script>

<!-- TODO: Replace this temporary solution with an actual markup requirements -->
<style scoped lang="scss">
.badge {
  &__digital {
    background-color: #ecf6ff;
    color: #327393;
  }
}

.stocktype {
  &-0 {
    color: #ce3037;
  }
  &-1 {
    color: #4f9e34;
  }

  &-2 {
    color: #0070c0;
  }

  &-3 {
    color: #4f9e34;
  }
}
</style>
